module.exports = __webpack_public_path__ + "assets/img/Groups788.d547e1c2.png";